import axiosInstance from "../../../interceptor/intercetptor-inctence";

export const addSign = (formData) => {
    return axiosInstance.post(`/api/lab-user/update-signature`, formData);
}

export const updateConvertionRate = (formData) => {
    return axiosInstance.post(`/api/lab-user/update-conversion-rates`, formData);
}

export const addHeaderFooterValue = (formData) => {
    return axiosInstance.post(`/api/lab-user/update-setting`, formData);
}

export const updateDateTimeFormat = (formData) => {
    return axiosInstance.post(`/api/lab-user/update-date-time-format`, formData);
}

export const updateTaxConfiguration = (formData) => {
    return axiosInstance.post(`/api/lab-user/update-tax-configuration`, formData);
}
